import React, { useState, useEffect, useRef, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setScaleWeightInfo, connectedScaleSocket } from '../../../actions/scale-socket';
import ScaleIcon from '../../../../assets/images/target_eg.png';
import config from '../../../constants/config';
import { getScaleMachineDetails, setScaleMachineDetails } from '../../../helpers/session';
import { OverlayTrigger, Popover } from 'react-bootstrap';

export const ScaleSocket = ({ scaleDevice }) => {
    const dispatch = useDispatch();
    const scaleSocket = useSelector(state => state.scaleSocket);
    const WSURL = (scaleDevice && scaleDevice.scaleSocketURL) ? scaleDevice.scaleSocketURL
        : config.remotescalesocket.SOCKET_URL;
    const socketRef = useRef(null);
    const { socketConneted } = useMemo(() => {
        const { isConnected } = scaleSocket;
        return { socketConneted: isConnected }
    }, [scaleSocket]);
    // const [socketConnected, setSocketConnected] = useState(false);
    const [runningWeight, setRunningWeight] = useState(null);
    const [isWeightStable, setIsWeightStable] = useState(false);

    const getScaleDeviceDetails = getScaleMachineDetails();
    const scaleDeviceName = getScaleDeviceDetails && getScaleDeviceDetails.name ?
        getScaleDeviceDetails.name : "No Scale name";

    useEffect(() => {
        if (!socketRef.current) {
            socketRef.current = new WebSocket(WSURL);
            socketRef.current.onopen = () => handleSocketConnectStatus(true);
            socketRef.current.onmessage = handleSocketMessage;
            socketRef.current.onerror = handleSocketError;
            socketRef.current.onclose = () => handleSocketConnectStatus(false, 'onclose');
        }

        return () => {
            if (socketRef.current) {
                socketRef.current.close();
                dispatch(connectedScaleSocket(false));
            }
        };
    }, []);

    const handleSocketConnectStatus = (status, action = null) => {
        dispatch(connectedScaleSocket(status));
        //if (!action) setSocketConnected(status);
    };

    const handleSocketMessage = (event) => {
        const message = event.data && typeof event.data === 'string' ? JSON.parse(event.data) : null;
        if (!message) return;

        const { weight, scale_at_standstill } = message;
        setRunningWeight(weight);
        if (scale_at_standstill) {
            dispatch(setScaleWeightInfo(message));
            setIsWeightStable(true);
        } else {
            setIsWeightStable(false);
        }
    };

    const handleSocketError = (error) => {
        if (error) {
            handleSocketConnectStatus(false);
            setScaleMachineDetails();
            console.error('WebSocket Error:', error);
        }
    };

    return (
        <>
            {socketConneted && (
                <OverlayTrigger
                    placement="bottom"
                    overlay={
                        <Popover className="scale-device__name-popover">
                            <Popover.Content >
                                <span>{scaleDeviceName}</span>
                            </Popover.Content>
                        </Popover>
                    }
                >
                    <span className={`ml-3 scale_weight_container ${!isWeightStable ? 'shake_me scale-weight' : 'text-success scale-weight'}`}>
                        <img className='scale_weight_img' src={ScaleIcon} alt="ScaleIcon" />
                        <span className="ml-1">{runningWeight}</span>
                    </span>
                </OverlayTrigger>

            )}
        </>
    );
};
